
export const OverDueFirstResponseText = 'The time between the first customer email in a new conversation and the first response by a member.'
export const OverDueResolutionText = "The total time conversation spends in Open status."

export const ApplyOnOptions = [
    {label: 'All conversations', value: 'all'},
    {label: 'Inbound conversations', value: 'inbound'},
    {label: 'Outbound conversations', value: 'outbound'},
    {label: 'Conversations manually added to shared mailbox', value: 'manually_added'},
]

export const MockTagOptions = [
  {label: 'All conversations', value: 'all'},
  {label: 'Inbound conversations', value: 'inbound'},
  {label: 'Outbound conversations', value: 'outbound'},
  {label: 'Conversations manually added to shared mailbox', value: 'manually_added'},
]
  
export const InitialUserList = [
    {name: 'Assignee', value: 'assignee'},
    {name: 'Assigner', value: 'assigner'}
]

export const DropDownbuttons = [{
	value: 'cancel',
	content: 'Cancel',
	title: 'Cancel',
  hoverStyle: {
    "backgroundColor": "#f3f3f3",
  }

},
{
	value: 'apply',
	content: 'Apply',
	title: 'Apply',
	disabled: false,
	style: {
		"backgroundColor": "#506DFF",
		"color": "white",
    marginRight: '19px'
	},
  hoverStyle: {
    "backgroundColor": "#4763F0 !important",
  }
}];


export const LoadingStatus = {
  CREATING_SLA_IN_PROGRESS: 'CREATING_SLA_IN_PROGRESS',
  UPDATING_SLA_IN_PROGRESS: 'UPDATING_SLA_IN_PROGRESS',
  FETCHING_SLA_IN_PROGRESS: 'FETCHING_SLA_IN_PROGRESS',
  TOGGLING_SLA_IN_PROGRESS: 'TOGGLING_SLA_IN_PROGRESS',
  REORDER_SLA_IN_PROGRESS: 'REORDER_SLA_IN_PROGRESS',
  UPDATING_SLA_SETTINGS: 'UPDATING_SLA_SETTINGS',
}


export const ContentTypes = {
 EMPTY: 'EMPTY',
 UPGRADE: 'UPGRADE',
}

export const SlaViewPageDescription = `The first SLA policy that matches the conditions will be applied to the conversation.
If you reorder, edit or disable SLAs it will not affect conversations which already have an SLA applied to them.`

export const SlaEditPageDescription = 'Editing this SLA will not affect conversations which already have this SLA applied to them.'
export const SlaTagDeletedError = 'SLA is disabled as one or more tag has been deleted from the shared mailbox. Please review the policy and save again to enable the SLA.'

export const ModalText = {
  toggleLimitExceedText: 'You can have a maximum of 20 enabled SLA policies at a time. Please disable other policies which are not in use or contact support for further assistance.',
  createLimitExceedText: 'SLA policy is created but it has been disabled as you can have a maximum of 20 enabled policies at a time. Please disable other policies which are not in use or contact support for further assistance.',
  toggleUpgradeLimitText: 'Your current plan only allows only 1 SLA pollicy enabled at a time. Upgrade your plan to enable more policies.',
  createUpgradeLimitText: 'SLA policy is created but it has been disabled as your current plan allows only 1 policy enabled at a time. Upgrade your plan to enable more policies.'
}

export const ModalType = {
  TOGGEL_LIMIT_MODAL: 'TOGGEL_LIMIT_MODAL',
  CREATE_LIMIT_MODAL : 'CREATE_LIMIT_MODAL',
  TOGGLE_UPGRADE_LIMIT_MODAL: 'TOGGLE_UPGRADE_LIMIT_MODAL',
  CREATE_UPGRADE_LIMIT_MODAL: 'CREATE_UPGRADE_LIMIT_MODAL',
}

export const MAX_SLA_TIME_LIMIT = 1000; //1000 hours as the max

export const MockSlaSettings = {
    "apply_on": "conv_created",
    "notify_on_delete": {
      "notify_alias": [
        "assignee"
      ],
      "notify_users": [
        
      ]
    },
    "updated": {
      "user_id": 0,
      "timestamp": 0
    }
  }


  export const learnMoreLink = 'https://help.hiverhq.com/working-with-slas';
  export const ManageSlaLink = 'https://help.hiverhq.com/working-with-slas/Managing-SLA-policies';

// SM Properties
export const FIRST_SLA_CREATED_SM_PROPERTY = 'first_sla_created';
